import { LibType, PanoTaskType } from '@types';

export const LIB_SIZE_LIMIT = {
  [LibType.image]: 10485760, // 10MB
  [LibType.audio]: 20971520, // 20MB
  [LibType.video]: 524288000, // 500MB
  [LibType.panoVideo]: 10 * 1024 * 1024 * 1024, // 10GB
  [LibType.sequenceFrame]: 716800, // 700K
  [LibType.doc]: 50 * 1024 * 1024, // 50MB
};

export const LIB_FRAME_LIMIT = 144;

export const SPACE_WARNING_SIZE = 104857600; // 空间小于100MB提醒

export const TASK_SIZE_LIMIT = {
  [PanoTaskType.single]: 125829120, // 120MB
  [PanoTaskType.group]: 62914560, // 60MB
  matrix: 314572800, // 300MB
  video: 10 * 1024 * 1024 * 1024, // 10GB
};

export const MATRIX_IMAGE_LIMIT = 8000; // 8000px

export const SORT_DEFAULT = 0; // 素材库默认按修改时间排序
